/** this script is written to extend the features of the theme 
*  Written by: musaibdar64@gmail.com
* Features added ==> quick add to cart and variant select for product card
**/

const Utility = {
    serializeForm(form) {
    const obj = {};
    const formData = new FormData(form);

    for (const key of formData.keys()) {
      const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
      if (regex.test(key)) {
        obj.properties = obj.properties || {};
        obj.properties[regex.exec(key)[2]] = formData.get(key);
      } else {
        obj[key] = formData.get(key);
      }
    }

    return JSON.stringify(obj);
  },
    formatMoney(cents, format) {
    if (format == null || format == undefined){
      format = theme.settings.moneyWithCurrencyFormat || "${{ amount }}";
    }
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) {
      
      return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) { return 0; }
      number = (number/100.0).toFixed(precision);
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  },
  
   fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  }
  /**
 * Product Form Components
 *
 */
class CustomProductBuy extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.cartElement = document.querySelector('cart-form');   
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('is-loading');

    addItems.push(JSON.parse(Utility.serializeForm(this.form)));
    const body = JSON.stringify({items: addItems});
    
    fetch(`${theme.routes.cartAdd}`, { ...Utility.fetchConfig(), body })
    .then((response) => response.json())
    .then((res) => {
      let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
      console.log('dataJSON===>', dataJSON);
      if(dataJSON.errors){
        console.log('error in updating the cart');
        return;
      }
      submitButton.classList.add('is-success');
      if(this.cartElement){
        /** update the cart elements **/
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
           bubbles: true
         }));
        /** open the cart drawer **/
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        
      }else{
        window.location.href = window.routes.cart_fetch_url;
      }      
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('is-loading');
      submitButton.classList.remove('is-success');
      submitButton.removeAttribute('disabled');
    });
  }

}
customElements.define('custom-product-buy', CustomProductBuy);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;
    this.container = this.closest('product-block');
  }

  connectedCallback() {
    // Element Connected callback
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    this.setCurrentVariant();
     console.log(this.currentVariant);
     //this.updateVariantID(this.currentVariant)
    if (!this.currentVariant) {
      this.toggleAddButton('disable');
    } else {
      this.priceUpdate(this.currentVariant, this.container)      
      this.updateVariantID(this.currentVariant);
      this.toggleAddButton('enable');
    }
  }


  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }


  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    this.currentVariant = false;
    let options =  this._getOptionsFromSelect();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });
  }


  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateVariantID(currentVariant) {
    if (!currentVariant) return;
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Price details based on current variant
   */
  priceUpdate(currentVariant, container){
    let priceElement = container.querySelector('[data-current-price]');
    let hasComparePrice = currentVariant.compare_at_price, newPriceElement = undefined;
    if(hasComparePrice && currentVariant.price < currentVariant.compare_at_price){
        newPriceElement = `<div class="price price--on-sale"><div class="price__default"><span class="price__from">From</span><span class="price__current">${Utility.formatMoney(currentVariant.price, theme.settings.moneyWithCurrencyFormat)}</span><span class="price__was">${Utility.formatMoney(currentVariant.compare_at_price, theme.settings.moneyWithCurrencyFormat)}</span></div><span class="price-label price-label--sale">Sale</span></div>`;
    }else{
        newPriceElement = `<div class="price"><div class="price__default"><span class="price__current">${Utility.formatMoney(currentVariant.price, theme.settings.moneyWithCurrencyFormat)}</span></div></div>`;
    }
    priceElement.innerHTML = newPriceElement;
  }


  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.theme.strings.noVariant;
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.theme.strings.noStock;
    } else {
      this.addBtn.removeAttribute('disabled');
        this.addBtn.querySelector('.add-text').textContent = window.theme.strings.addToCart;
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

